import { Space } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Button from "../../../Components/Button"

// Pill / segmented toggle, matching the app's DashboardFiltersBlock pattern
// (Space.Compact of compact-btn Buttons). options: [{ value, label }].
const Toggle = ({ value, onChange, options, size = "large" }) => {
  const { t } = useTranslation()
  return (
    <Space.Compact size={size}>
      {options.map((o) => (
        <Button
          key={o.value}
          className={cls("compact-btn", { active: value === o.value })}
          onClick={() => onChange(o.value)}
          text={t(o.label)}
        />
      ))}
    </Space.Compact>
  )
}

export default Toggle
